import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import draftjs from "draft-js";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog } from "../../Actions/Dialogs/DialogActions";
import Button from "../Buttons/Button";
import { convertDraftToHTML, convertHTMLToDraft, HTMLEditor } from "../Forms/HTMLEditor/HTMLEditor";

const connector = connect();

type PropsFromRedux = ConnectedProps<typeof connector> & {
    dispatch: ThunkDispatch<any, any, any>;
};

interface Props extends PropsFromRedux {
    html: string;
    onSubmit: (html: string) => void;
    autoFocus?: boolean;
}

interface State {
    value: draftjs.EditorState;
}

export class HTMLEditorDialog extends React.Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props);

        this.state = {
            value: props.html ? convertHTMLToDraft(props.html) : draftjs.EditorState.createEmpty(),
        };
    }

    public handleChange = (editorState: draftjs.EditorState): void => {
        this.setState({
            value: editorState,
        });
    };

    public handleCancelClick = (): void => {
        this.props.dispatch(hideDialog());
    };

    public handleSubmitClick = (): void => {
        const html = convertDraftToHTML(this.state.value.getCurrentContent());

        this.props.onSubmit(html.trimEnd());
        this.props.dispatch(hideDialog());
    };

    public render(): React.ReactNode {
        return (
            <div className="html-editor-dialog">
                <HTMLEditor
                    value={this.state.value}
                    onChange={this.handleChange}
                    autoFocus={this.props.autoFocus}
                />
                <div className="buttons">
                    <Button type="button" classes={[ "button-cancel" ]} onClick={this.handleCancelClick}>Cancel</Button>
                    <Button type="button" classes={[ "button-save" ]} onClick={this.handleSubmitClick}>Save</Button>
                </div>
            </div>
        );
    }
}

export default connector(HTMLEditorDialog);
